<div
    style="display: -webkit-flex; display: flex; align-items: center; background-color: #161616; height: 30px; color: rgb(253, 253, 253); border-bottom: 1px solid #333333; margin-bottom:5px;">
    <span style="margin-left: 10px; ">
        <button mat-menu-item [routerLink]="['/']" [state]="{refineryConfigGuid: refineryConfigGuid}">
            <span>Refinery: {{refineryName}}</span>
            </button>
    </span>
</div>

<mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl" style="margin-right: 10px;">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node style="cursor: pointer; font-size: 9pt;" *matTreeNodeDef="let node" matTreeNodePadding
        matTreeNodePaddingIndent="10" [ngClass]="{'hidden': hideshowrow(node)}">
        <!-- use a disabled button to provide padding for tree leaf -->
        <button mat-icon-button disabled></button>
        <mat-icon class="mat-icon-rtl-mirror" [ngClass]="node.isSelected ? 'white-icon' : node.iconColorClass" style="margin-right: 0px;" >
            build_circle</mat-icon>
        <button [class]="node.isSelected ? 'white-icon' : node.iconColorClass" style="padding-left: 5px;background-color: transparent" mat-flat-button (click)="onNodeClicked(node)">{{node.name}}</button>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node style="cursor: pointer; font-size: 9pt;" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
        matTreeNodePaddingIndent="10">
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" (click)="onNodeClicked(node)">
            <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <mat-icon class="mat-icon-rtl-mirror" [ngClass]="node.isSelected ? 'white-icon' : node.iconColorClass" style="margin-right: 0px;">folder</mat-icon>
        <button [class]="node.isSelected ? 'white-icon' : node.iconColorClass" style="padding-left: 5px; background-color: transparent" mat-flat-button (click)="onNodeClicked(node)">{{node.name}}</button>
    </mat-tree-node>
</mat-tree>